import { Calculator } from "@googlemaps/markerclustererplus/dist/markerclusterer";
import { OperatingArea } from "@optimusride/client-library/@types/grpc/site";
import { DriveGear } from "@optimusride/client-library/@types/grpc/vehicle_status";
import { convertLatLng, isStringInteger } from "../../common/utils";

export type Address = {
    address1?: string;
    address2?: string;
    city?: string;
    state?: string;
    postalcode?: string;
    country?: string;
};

export const getAddressString = (address?: Address) => {
    if (!address) return "";

    let { address1 = "", address2 = "" } = address;
    let cityStateZip = "";

    if (address1) {
        address1 += "\n";
    }

    if (address2) {
        address2 += "\n";
    }

    if (address.city) {
        cityStateZip += `${address.city}`;
    }

    if (address.state) {
        cityStateZip += `${cityStateZip !== "" ? ", " : ""}${address.state}`;
    }

    if (address.postalcode) {
        cityStateZip += `${cityStateZip !== "" ? " " : ""}${address.postalcode}`;
    }

    if (!address1 && !address2 && !cityStateZip) return "";

    return `${address1}${address2}${cityStateZip}`;
};

const VehicleNameRegex = /(\D+)(\d+)/gm;

export const splitVehicleID = (vehicleID: string) => vehicleID
    .split(VehicleNameRegex)
    .map((value) => (isStringInteger(value) ? value : value.charAt(0)))
    .join("");

export const SVG_BASE = "data:image/svg+xml;charset=UTF-8;,";

// Custom Site Zoom levels for each of the operating areas
// The keys are the operation area ids and the values are the zoom level
const SITE_ZOOM_LEVELS: { [key: number]: number } = {
    1: 16,
    3: 17,
    4: 17,
    5: 16,
    6: 17,
    7: 15,
};

export const createMapOptions = (
    selectedSite?: OperatingArea,
): google.maps.MapOptions | undefined => selectedSite?.latLonCenter && {
    center: convertLatLng(selectedSite.latLonCenter),
    zoom: SITE_ZOOM_LEVELS[selectedSite.id] || 17,
    styles: [
        {
            featureType: "poi",
            elementType: "labels.text",
            stylers: [
                {
                    visibility: "off",
                },
            ],
        },
        {
            featureType: "poi.business",
            stylers: [
                {
                    visibility: "off",
                },
            ],
        },
        {
            featureType: "road",
            elementType: "labels.icon",
            stylers: [
                {
                    visibility: "off",
                },
            ],
        },
        {
            featureType: "transit",
            stylers: [
                {
                    visibility: "off",
                },
            ],
        },
    ],
};

export const defaultMarkerCalculator: (clusterGrouping?: number) => Calculator = (
    (clusterGrouping = 1) => (clusterMarkers) => {
        const customText = clusterMarkers
            .map((m) => m.getLabel()?.text)
            .filter((text) => text)
            .join("/");
        return ({
            text: `${clusterMarkers.length / clusterGrouping}`,
            title: customText,
            index: 0,
        });
    });

export const VEHICLE_DRIVE_GEAR_STATUS = {
    [DriveGear.FORWARD]: "home.vehicleStatus.driveGear.forward",
    [DriveGear.REVERSE]: "home.vehicleStatus.driveGear.reverse",
    [DriveGear.PARK]: "home.vehicleStatus.driveGear.park",
    [DriveGear.OFF]: "home.vehicleStatus.driveGear.off",
    [DriveGear.NEUTRAL]: "home.vehicleStatus.driveGear.neutral",
    [DriveGear.UNKNOWN]: "home.vehicleStatus.driveGear.unknown",
};
